import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";

// Action to grant premium access to a user
export const grantPremiumAccessAction = createAsyncThunk(
  "premiumAccess/grantPremium",
  async ({ userId, period, durationMonths }, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/admin/premium/grant-premium", {
        userId,
        period,
        ...(durationMonths && { durationMonths }),
      });

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to grant premium access";
      return rejectWithValue(errorMessage);
    }
  }
);

// Action to revoke premium access from a user
export const revokePremiumAccessAction = createAsyncThunk(
  "premiumAccess/revokePremium",
  async ({ userId, reason }, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/admin/premium/revoke-premium", {
        userId,
        ...(reason && { reason }),
      });

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to revoke premium access";
      return rejectWithValue(errorMessage);
    }
  }
);
